import React, { ReactNode } from 'react';
import { Box, SxProps } from '@mui/material';

interface Props {
  sx?: SxProps;
  children: ReactNode;
  visible?: boolean; 
}

export function AppRow({ sx, children, visible = true }: Props): JSX.Element {
  return (
    <Box
      sx={{
        display: visible ? 'flex' : 'none', 
        alignItems: 'center',
        justifyContent: 'space-between',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
